import styled, { css } from 'styled-components';

export const Overlay = styled.div`
    ${({ theme }) => css`
        background: ${theme.modules.courseCompare.overlay.background};
        position: fixed;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        z-index: 1000;
    `}
`;

export const Container = styled.div`
    ${({ theme }) => css`
        position: fixed;
        top: 5%;
        bottom: 2rem;
        max-width: calc(100% - 3rem);
        right: 0;
        border-bottom: 1rem solid ${theme.modules.courseCompare.borderColor};
        border-radius: 0 0 0 0.875rem;
        z-index: 1001;

        @media ${theme.breakpoints.medium.media} {
            max-width: calc(98% - 4rem);
        }
    `}
`;

export const TableWrapper = styled.div<{ $isOpen: boolean }>`
    height: calc(100%);
    width: 0;

    ${({ $isOpen }) =>
        $isOpen &&
        css`
            width: auto;
        `}
`;
